import {
  USA_PROVINCE_NAMES,
  USAProvinceName,
} from "@redotech/locale/provinces";
import MapIcon from "@redotech/redo-icons/map-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const StateFilter: ArrayStringTableFilter<USAProvinceName> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  data: {
    name: "state",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "state",
  Icon: MapIcon,
  operators: [
    ArrayStringFilterOperator.NONE_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.ANY_OF,
  ],
  values: USA_PROVINCE_NAMES,
  displayName: "State",
};
